import resolveConfig from 'tailwindcss/resolveConfig'

export const twTheme = resolveConfig(
	require('@cocoonspace/config/tailwind.config'),
)
